import { render, staticRenderFns } from "./BlockedItemListItem.vue?vue&type=template&id=481d3f04"
import script from "./BlockedItemListItem.vue?vue&type=script&lang=js"
export * from "./BlockedItemListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports